module.exports = __webpack_public_path__ + "static/media/default-user-picture.5e3c151c.webp";